const CATEGORY_END_POINT = 'jfs/v2/dsp/pc/category'
const BILL_END_POINT = 'jfs/v1/dsp/bill'
const ORDER_END_POINT = 'jfs/v1/dsp/order'
const AGENT_END_POINT = 'jfs/v1/dsp/agent'
const PRODUCT_END_POINT = 'jfs/v1/dsp/pc/product'
const STANDING_INSTRUCTION_END_POINT = 'jfs/v1/dsp/si'
const BENEFICIARY_END_POINT = 'jfs/v1/dsp/beneficiary'
const USER_END_POINT = 'jfs/v1/dsp/user'
const EMS_END_POINT = 'jfs/ems/v2/ext/entity'
const { REACT_APP_SUPERSET_BASE_URL: supersetBaseUrl } = window?._env_ ?? {}

const sitEndPoints = {
  APPAuth: '/jfs/v1/app/authenticate', // working app/auth
  Login: '/jfs/v1/user/authenticate', // working user/auth
  ReGenerateToken: 'user/auth/regenerate',
  GetMerchant: '/jfs/v1/merchant/searchMerchant', // working
  forgotResetPassword: '/jfs/v1/user/authenticate/credentials/reset', // working
  createPassword: 'api/v1/user?changePassword',
  createPasswordVerifyOTP: 'api/v1/user?changePasswordVerifyOTP',
  Settlements: 'jfs/v1/merchant/settlements', // working
  Transaction: '/jfs/v1/merchant/transaction',
  BulkFileUpload: '/bps/jfs/v1/utilities/file/uploadInitiate',
  BulkFildownloadAll: '/transaction/getranListAll',
  BulkFiledownloadWithStatus: '/transaction/getTranlist',
  loginVerifyOTP: '/idam-api/api/v1/verifyOtp',
  GetUsers: '/idam-api/api/v1/user/getuser',
  AddUser: '/idam-api/api/v1/user/create',
  searchMerchants: '/jfs/v1/merchant/searchMerchant', // working
  InitiateRefund: '/jfs/v1/merchant/transactions/refunds',
  DeleteUser: '/idam-api/api/v1/user/delete',
  UpdateUser: '/idam-api/api/v1/user/update',
  SettlementCSVDownload: '/jfs/v1/merchant/getSettlementsFile/',
  SettlementPDFDownload: '/report/report/pdf/download',
  SettlementGenerate: '/report/report/mpa/generate',
  SettlementRemove: '/report/report/mpa/remove',
  faqs: 'https://www.jiopay.in/help-center',
  contactUs: 'https://www.jiomoney.com/contactus.html',
  merchantAgreement: 'https://www.jiomoney.com/merchants.html',
  tnc: 'https://www.jiopay.in/terms-conditions',
  billpayTnC: 'https://www.jiopay.in/billpay-terms-conditions',
  privactPolicy: 'https://www.jiopay.in/privacy-policy',
  grevienceRedressal: 'https://www.jiopay.in/images/pdf/Complaint%20Resolution/Grievance_Redressal_Policy.pdf',
  kycAML: 'https://www.jiopay.in/merchant-onboarding',
  Logout: 'jfs/v1/user/session/expire', // working
  AppExpire: 'jfs/v1/app/session/expire',
  InitiateBulkRefund: '/transaction/invokejob',
  deleteBulkRefund: '/transaction/upload/refundTxnDelete',
  generateOtp: '/jfs/v1/user/authenticate',
  invoice: '/jfs/v1/merchant/gstinvoices/',
  PaymentAcceptance: 'jfs/v1/merchant/getMerchantConfig', // working
  appSessionExtend: '/jfs/v1/app/authenticate',
  userSessionExtend: '/jfs/v1/user/authenticate',
  GetQRCode: '/jfs/v1/merchant/qr',
  downloadQrCode: '/jfs/downloadQR', //FIXME: Add the download url for downloading QR code
  banksList: '/jfs/v1/getBankList',
  fetchbanksList: '/jfs/v1/fetchBankList',
  banksByMobileNo: '/jfs/v1/merchant/getUPIAccountDetails',
  createMerchant: 'jfs/v1/merchant/addAccountDetails',
  searchIFSC: '/jfs/v1/getBranchListByCityAndBank', //FIXME: check with API gateway
  validateIFSC: '/jfs/v1/merchant/getBranchDetailsByIfsc',
  removeBankAccount: '/jfs/v1/user/removeBankAccount/', //FIXME: update
  getAccountDetails: '/jfs/v1/merchant/getAcctDetails/', //FIXME: update
  generateOtpOnSignUp: '/jfs/v1/merchant/onboard',
  onboardMerchant: '/jfs/v1/merchant/onboard',
  getContent: '/jfs/v1/merchant/learnvideos',
  searchIfscThroughBranchId: 'jfs/v1/getIfscCodeByBranch',
  createIntent: '/payments/jfs/v1/payments/intent',
  checkStatus: '/payments/jfs/v2/payments/status',
  getAllPaymentLinks: '/payments/jfs/cl/get_payment_links',
  createPaymentLink: '/payments/jfs/cl/get_short_link',
  checkPaymentLinkStatus: '/payments/jfs/cl/check_collect_link_status',
  sendPaymentLink: '/payments/jfs/cl/sent_payment_link',
  cancelPaymentLink: '/payments/jfs/cl/cancel_collect_link',
  getPaymentLinkData: '/payments/jfs/cl/get_collect_link_data',
  getSettlementStats: '/jfs/v1/merchant/getSettlementSummary',
  createUserDevice: '/jfs/v1/device',
  updateUserDevice: '/jfs/v1/device/update',
  getTxnsInsightsSummary: 'jfs/v1/merchant/transactions/insightsSummary', //TODO: update endpoints
  getSettlementInsightsSummary: 'jfs/v1/merchant/settlementSummary', //TODO: update endpoints
  getInsightsRecord: 'jfs/v1/merchant/transactions/insightsGraph', //TODO: update endpoints
  getApiCredentials: '/jfs/v1/app/client/details',
  exportBulkRefund: '/bps/jfs/v1/utilities/file/download',
  BulkRefundSampleFileDownload: '/bps/jfs/v1/utilities/file/download',
  BulkRefundUploadConfirm: '/bps/jfs/v1/utilities/file/uploadConfirm',
  BulkRefundList: '/bps/jfs/v1/utilities/file/list',
  getSubscriptions: '/mandate/jfs/v1/mandate/history',
  getSubscriptionTxnsHistory: '/jfs/v1/merchant/transactions',
  getSubsTxnDetails: '/jfs/v1/merchant/transaction',
  getUsers: '/payments/ems/v1/entity/user/details/retrieve',
  isSuperMerchant: '/payments/ems/v1/entity/hirearchy/retrieve',
  addUser: '/payments/eos/v2/entity/user',
  updateUser: '/payments/ems/v1/entity/update-permission', // TODO: when edit API comes
  blockUnblockUser: '/payments/ems/v1/entity/user/update',
  getUserPermissions: '/payments/ems/v1/entity/user/permission-list/retrieve',
  getMasterPermissionList: '/payments/ems/v1/entity/master/permission-list/retrieve',
  getCampaigns: '/jfs/v1/merchant/offer/fetch',
  getCampaignsSummary: '/jfs/v1/merchant/offer/summary',
  getCampaignDetails: '/jfs/v1/merchant/offer/fetchById',
  updateCampaign: 'jfs/v1/merchant/offer/update',
  createCampaign: 'jfs/v1/merchant/offer/add',
  getMasterList: 'jfs/v1/merchant/offer/masterList',
  getCampaignGraphData: 'jfs/v1/merchant/offer/dayWiseDistribution',
  exportCampaign: '/jfs/v1/merchant/offer/exportReport',
  TransactionsV3: '/jfs/v3/merchant/transactions',
  getSubscriptionTxnsHistoryV3: '/jfs/v3/merchant/transactions',
  TransactionColumnV3: '/jfs/v3/merchant/transactions/columns',
  getSubsTxnDetailsV3: '/jfs/v3/merchant/transactions',
  txnDetailsV3: '/jfs/v3/merchant/transactions',
  getTxnsSummaryV3: '/jfs/v3/merchant/transactions/summary',
  searchMerchantMetaData: '/payments/ems/v1/entity/user/list/retrieve',
  // downloads:
  getDownloadTxnsRefundsReport: '/jfs/v3/merchant/transactions/report',
  getTxnsRefundsDownloadList: '/jfs/v3/merchant/transactions/report/list', //list
  getTxnsRefundsDownloadFile: '/jfs/v3/merchant/transactions/report/fetch', //Download
  deleteTxnsRefundsReport: '/jfs/v3/merchant/transactions/report/delete', //delete
  getDownloadSettlementsReport: '/jfs/v2/merchant/settlements/report',
  getSettlementsDownloadList: '/jfs/v2/merchant/settlements/report/list', //list
  getSettlementsDownloadFile: '/jfs/v2/merchant/settlements/report/fetch', //Download
  deleteSettlementsReport: '/jfs/v2/merchant/settlements/report/delete', //delete
  //Settlements reports
  getSettlementReportList: '/jfs/v1/merchant/settlements/reportConfig/list',
  deleteSettlementReportFormat: '/jfs/v1/merchant/settlements/reportConfig/delete',
  deleteSettlementReport: '/jfs/v1/merchant/deleteSettlementReport',
  updateSettlementReportFormat: '/jfs/v1/merchant/settlements/reportConfig/update',
  addSettlementReportFormat: '/jfs/v1/merchant/settlements/reportConfig/insert',
  downloadSettlementReportFormat: '/jfs/v1/merchant/settlements/reportConfig/getSampleFile',

  getVoiceNotification: '/jfs/v1/getAudio',

  checkUserOnIDAM: '/jfs/v1/user/authenticate',
  setPasswordOnIDAM: '/jfs/v1/user/authenticate/credentials/set',

  ActivateQr: '/jfs/v1/merchant/activateQr',
  MidQRList: '/jfs/v1/getCso',
  CreateUser: '/jfs/v1/s2auth/user',
  ValidateMobileNumber: '/jfs/v1/s2auth/user/validate',
  vaultSummary: '/jfs/v1/merchant/cardvault/summary',
  vaultHistory: '/jfs/v1/merchant/cardvault/searchTokenisationHistory',
  getDownloadVaultReport: '/jfs/v1/merchant/cardvault/report',
  getVaultColumns: '/jfs/v1/merchant/cardvault/columns',
  getConfigList: '/jfs/v1/merchant/getConfigListMeta',

  //voicebox
  voiceboxes: 'jfs/v1/merchant/ams/device/getDeviceList',
  voiceboxInvoices: 'jfs/v1/merchant/ams/device/getInvoiceList',
  downloadPdfInvoice: '/payments/jfs/v2.0/invoice/service/retrieve',
  changeDeviceConfiguration: '/dsm/v1/vb/changeDeviceConfiguration',

  //beneficiary
  addBeneficiary: '/jfs/ems/v1/entity/create',
  bulkBeneficiaryUploadList: '/jfs/bos/v1/entity/upload/list',
  allBeneficiariesList: '/jfs/ems/v1/entity/childentities',
  addNewBeneficiaryType: '/jfs/ems/v1/entity/config/create',
  uploadBulkBeneficiaryFile: '/jfs/bos/v1/entity/upload/beneficiary',
  downloadBulkBeneficiaryFile: '/jfs/bos/v1/entity/file/download/beneficiary',
  sampleFileDownload: '/jfs/v1/merchant/getSampleFile',
  exportBulkBeneficiary: '/jfs/bos/v1/export',
  //split
  getSplitSettlementEnabled: 'jfs/v1/entity/payout/config/retrieve',
  searchSettlementDetails: 'jfs/v1/merchant/searchSettlementDetails',
  createSplitSettlements: 'jfs/v2/settlement/payout',

  //Payout
  payoutHistoryList: '/jfs/',
  payoutLinksList: '/jfs/',

  //billpayment apis
  getCategoryListV2: `/${CATEGORY_END_POINT}/getCategoryListV2`,
  getDueBillList: `/${BILL_END_POINT}/getDueBillList`,
  getBillFetch: `/${BILL_END_POINT}/billFetch`,
  getOrderHistory: `/${ORDER_END_POINT}/getOrderHistory`,
  searchAgent: `/${AGENT_END_POINT}/searchAgent`,
  onboardAgent: `/${AGENT_END_POINT}/onboardAgent`,
  getOperatorList: `/${PRODUCT_END_POINT}/getProductList`,
  getSpinnerList: `/${BENEFICIARY_END_POINT}/getBeneficiaryList`,
  getAuthenticatorList: `/${PRODUCT_END_POINT}/getAuthenticatorList`,
  registerBiller: `/${USER_END_POINT}/addRegisterProduct`,
  createOrder: `/${ORDER_END_POINT}/create`,
  checkPaymentStatus: `/${ORDER_END_POINT}/checkStatus`,
  getLocationList: `/${PRODUCT_END_POINT}/getSupplierLocationList`,
  seachBillers: `/${PRODUCT_END_POINT}/searchProducts`,
  searchEntity: `/${EMS_END_POINT}/searchEntity`,
  searchConfig: '/jfs/ems/v1/entity/config/search',
}

const APIEndPoints = {
  APPAuth: sitEndPoints.APPAuth,
  Login: sitEndPoints.Login,
  ReGenerateToken: sitEndPoints.ReGenerateToken,
  GetMerchant: sitEndPoints.GetMerchant,
  forgotResetPassword: sitEndPoints.forgotResetPassword,
  createPassword: sitEndPoints.createPassword,
  createPasswordVerifyOTP: sitEndPoints.createPasswordVerifyOTP,
  Settlements: sitEndPoints.Settlements,
  BulkFileUpload: sitEndPoints.BulkFileUpload,
  BulkFildownloadAll: sitEndPoints.BulkFildownloadAll,
  BulkFiledownloadWithStatus: sitEndPoints.BulkFiledownloadWithStatus,
  loginVerifyOTP: sitEndPoints.loginVerifyOTP,
  GetUsers: sitEndPoints.GetUsers,
  isSuperMerchant: sitEndPoints.isSuperMerchant,
  AddUser: sitEndPoints.AddUser,
  searchMerchants: sitEndPoints.searchMerchants,
  InitiateRefund: sitEndPoints.InitiateRefund,
  DeleteUser: sitEndPoints.DeleteUser,
  UpdateUser: sitEndPoints.UpdateUser,
  SettlementCSVDownload: sitEndPoints.SettlementCSVDownload,
  SettlementPDFDownload: sitEndPoints.SettlementPDFDownload,
  SettlementGenerate: sitEndPoints.SettlementGenerate,
  SettlementRemove: sitEndPoints.SettlementRemove,
  faqs: sitEndPoints.faqs,
  contactUs: sitEndPoints.contactUs,
  merchantAgreement: sitEndPoints.merchantAgreement,
  kycAML: sitEndPoints.kycAML,
  tnc: sitEndPoints.tnc,
  grevienceRedressal: sitEndPoints.grevienceRedressal,
  privactPolicy: sitEndPoints.privactPolicy,
  Logout: sitEndPoints.Logout,
  AppExpire: sitEndPoints.AppExpire,
  InitiateBulkRefund: sitEndPoints.InitiateBulkRefund,
  deleteBulkRefund: sitEndPoints.deleteBulkRefund,
  generateOtp: sitEndPoints.generateOtp,
  invoice: sitEndPoints.invoice,
  samplepdf: 'https://file-examples.com/wp-content/uploads/2017/10/file-sample_150kB.pdf',
  samplexlsx: 'https://file-examples.com/wp-content/uploads/2017/02/file_example_XLS_10.xls',
  PaymentAcceptance: sitEndPoints.PaymentAcceptance,
  appSessionExtend: sitEndPoints.appSessionExtend,
  userSessionExtend: sitEndPoints.userSessionExtend,
  GetQRCode: sitEndPoints.GetQRCode,
  downloadQrCode: sitEndPoints.downloadQrCode,
  banksList: sitEndPoints.banksList,
  fetchbanksList: sitEndPoints.fetchbanksList,
  banksByMobileNo: sitEndPoints.banksByMobileNo,
  createMerchant: sitEndPoints.createMerchant,
  searchIFSC: sitEndPoints.searchIFSC,
  validateIFSC: sitEndPoints.validateIFSC,
  removeBankAccount: sitEndPoints.removeBankAccount,
  getAccountDetails: sitEndPoints.getAccountDetails,
  generateOtpOnSignUp: sitEndPoints.generateOtpOnSignUp,
  onboardMerchant: sitEndPoints.onboardMerchant,
  getContent: sitEndPoints.getContent,
  getVoiceNotification: sitEndPoints.getVoiceNotification,
  searchIfscThroughBranchId: sitEndPoints.searchIfscThroughBranchId,
  createIntent: sitEndPoints.createIntent,
  checkStatus: sitEndPoints.checkStatus,
  getAllPaymentLinks: sitEndPoints.getAllPaymentLinks,
  createPaymentLink: sitEndPoints.createPaymentLink,
  checkPaymentLinkStatus: sitEndPoints.checkPaymentLinkStatus,
  sendPaymentLink: sitEndPoints.sendPaymentLink,
  cancelPaymentLink: sitEndPoints.cancelPaymentLink,
  getPaymentLinkData: sitEndPoints.getPaymentLinkData,
  getSettlementStats: sitEndPoints.getSettlementStats,
  createUserDevice: sitEndPoints.createUserDevice,
  updateUserDevice: sitEndPoints.updateUserDevice,
  getSubscriptions: sitEndPoints.getSubscriptions,
  getTxnsInsightsSummary: sitEndPoints.getTxnsInsightsSummary,
  getSettlementInsightsSummary: sitEndPoints.getSettlementInsightsSummary,
  getInsightsRecord: sitEndPoints.getInsightsRecord,
  getApiCredentials: sitEndPoints.getApiCredentials,
  exportBulkRefund: sitEndPoints.exportBulkRefund,
  BulkRefundSampleFileDownload: sitEndPoints.BulkRefundSampleFileDownload,
  BulkRefundList: sitEndPoints.BulkRefundList,
  BulkRefundUploadConfirm: sitEndPoints.BulkRefundUploadConfirm,
  getUsers: sitEndPoints.getUsers,
  addUser: sitEndPoints.addUser,
  editUser: sitEndPoints.updateUser,
  blockUnblockUser: sitEndPoints.blockUnblockUser,
  getUserPermissions: sitEndPoints.getUserPermissions,
  getMasterPermissionList: sitEndPoints.getMasterPermissionList,
  getCampaigns: sitEndPoints.getCampaigns,
  getCampaignsSummary: sitEndPoints.getCampaignsSummary,
  getCampaignDetails: sitEndPoints.getCampaignDetails,
  updateCampaign: sitEndPoints.updateCampaign,
  createCampaign: sitEndPoints.createCampaign,
  getMasterList: sitEndPoints.getMasterList,
  getCampaignGraphData: sitEndPoints.getCampaignGraphData,
  exportCampaign: sitEndPoints.exportCampaign,
  TransactionsV3: sitEndPoints.TransactionsV3,
  getSubscriptionTxnsHistoryV3: sitEndPoints.getSubscriptionTxnsHistoryV3,
  TransactionColumnV3: sitEndPoints.TransactionColumnV3,
  txnDetailsV3: sitEndPoints.txnDetailsV3,
  getSubsTxnDetailsV3: sitEndPoints.getSubsTxnDetailsV3,
  getTxnsSummaryV3: sitEndPoints.getTxnsSummaryV3,
  getDownloadTxnsRefundsReport: sitEndPoints.getDownloadTxnsRefundsReport,
  getTxnsRefundsDownloadList: sitEndPoints.getTxnsRefundsDownloadList,
  getTxnsRefundsDownloadFile: sitEndPoints.getTxnsRefundsDownloadFile,
  deleteTxnsRefundsReport: sitEndPoints.deleteTxnsRefundsReport,
  getDownloadSettlementsReport: sitEndPoints.getDownloadSettlementsReport,
  getSettlementsDownloadList: sitEndPoints.getSettlementsDownloadList,
  getSettlementsDownloadFile: sitEndPoints.getSettlementsDownloadFile,
  deleteSettlementsReport: sitEndPoints.deleteSettlementsReport,
  getSettlementReportList: sitEndPoints.getSettlementReportList,
  deleteSettlementReportFormat: sitEndPoints.deleteSettlementReportFormat,
  deleteSettlementReport: sitEndPoints.deleteSettlementReport,
  updateSettlementReportFormat: sitEndPoints.updateSettlementReportFormat,
  addSettlementReportFormat: sitEndPoints.addSettlementReportFormat,
  downloadSettlementReportFormat: sitEndPoints.downloadSettlementReportFormat,
  searchMerchantMetaData: sitEndPoints.searchMerchantMetaData,
  checkUserOnIDAM: sitEndPoints.checkUserOnIDAM,
  setPasswordOnIDAM: sitEndPoints.setPasswordOnIDAM,

  //MID QR LIST - QR Agent
  MidQRList: sitEndPoints.MidQRList,

  //MID QR LIST - ACtivate
  ActivateQr: sitEndPoints.ActivateQr,
  CreateUser: sitEndPoints.CreateUser,
  ValidateMobileNumber: sitEndPoints.ValidateMobileNumber,

  vaultSummary: sitEndPoints.vaultSummary,
  vaultHistory: sitEndPoints.vaultHistory,
  vaultTokenTxnsHistory: sitEndPoints.TransactionsV3,
  getDownloadVaultReport: sitEndPoints.getDownloadVaultReport,
  getVaultColumns: sitEndPoints.getVaultColumns,
  getConfigList: sitEndPoints.getConfigList,

  //voicebox
  downloadPdfInvoice: sitEndPoints.downloadPdfInvoice,
  voiceboxes: sitEndPoints.voiceboxes,
  voiceboxInvoices: sitEndPoints.voiceboxInvoices,
  changeDeviceConfiguration: sitEndPoints.changeDeviceConfiguration,

  //Beneficiary
  addBeneficiary: sitEndPoints.addBeneficiary,
  bulkBeneficiaryUploadList: sitEndPoints.bulkBeneficiaryUploadList,
  allBeneficiariesList: sitEndPoints.allBeneficiariesList,
  addNewBeneficiaryType: sitEndPoints.addNewBeneficiaryType,
  uploadBulkBeneficiaryFile: sitEndPoints.uploadBulkBeneficiaryFile,
  downloadBulkBeneficiaryFile: sitEndPoints.downloadBulkBeneficiaryFile,
  sampleFileDownload: sitEndPoints.sampleFileDownload,
  exportBulkBeneficiary: sitEndPoints.exportBulkBeneficiary,
  //split
  getSplitSettlementEnabled: sitEndPoints.getSplitSettlementEnabled,
  searchSettlementDetails: sitEndPoints.searchSettlementDetails,
  createSplitSettlements: sitEndPoints.createSplitSettlements,

  //Payout
  payoutHistoryList: sitEndPoints.payoutHistoryList,
  payoutLinksList: sitEndPoints.payoutLinksList,

  //billpayment apis
  getCategoryListV2: sitEndPoints.getCategoryListV2,
  getDueBillList: sitEndPoints.getDueBillList,
  getBillFetch: sitEndPoints.getBillFetch,
  getOrderHistory: sitEndPoints.getOrderHistory,
  searchAgent: sitEndPoints.searchAgent,
  onboardAgent: sitEndPoints.onboardAgent,
  getOperatorList: sitEndPoints.getOperatorList,
  getSpinnerList: sitEndPoints.getSpinnerList,
  getAuthenticatorList: sitEndPoints.getAuthenticatorList,
  registerBiller: sitEndPoints.registerBiller,
  createOrder: sitEndPoints.createOrder,
  checkPaymentStatus: sitEndPoints.checkPaymentStatus,
  getLocationList: sitEndPoints.getLocationList,
  seachBillers: sitEndPoints.seachBillers,
  searchEntity: sitEndPoints.searchEntity,
  billpayTnC: sitEndPoints.billpayTnC,
  searchConfig: sitEndPoints.searchConfig,
  generateSupersetGuestTokens: 'jfs/v1/analytics/token/generate',
  getSupersetDashboardList: 'jfs/v1/analytics/dashboard/list',
  kycConsentApi: '/payments/ems/v1/consent/create',
}

export { APIEndPoints }
